// extracted by mini-css-extract-plugin
module.exports = {"Wrapper_Container":"NavbarSlider_Wrapper_Container__2HGd_","Title_Container2":"NavbarSlider_Title_Container2__bDj-6"};